import type { ComponentChildren } from 'preact';
import { forwardRef } from 'preact/compat';

import { cnBlockWrapper } from './block-wrapper.constants.js';

import './block-wrapper.css';

type BlockAttributes = {
    className?: string;
    children?: ComponentChildren;
};

export interface BlockWrapperProps extends BlockAttributes {}

export const BlockWrapper = forwardRef<HTMLElement, BlockWrapperProps>(({ className, children }, ref) => {
    return (
        <section className={cnBlockWrapper({}, [className])} ref={ref}>
            {children}
        </section>
    );
});
